import { createFileRoute } from '@tanstack/react-router';
import { ClerkScope } from '../auth/ClerkScope';
import { authFormAppearance } from '../pages/auth/authFormAppearance';
import { JoinTeamPage } from '../pages/dashboard/team/join/JoinTeamPage';

/** The URL parameters Clerk adds to an invitation link (`__clerk_ticket`,
 *  `__clerk_status`), kept under their own names so Clerk's sign-in and
 *  sign-up forms can read the ticket from the address bar, plus `team` when
 *  the dashboard sends someone here itself. */
export interface JoinSearch {
  __clerk_ticket?: string;
  __clerk_status?: string;
  team?: string;
}

const text = (value: unknown) => (typeof value === 'string' && value !== '' ? value : undefined);

/** Where a Team invitation lands (the gateway's teamJoinURL). Outside the
 *  dashboard layout, because a signed-out invitee signs in or up here first. */
export const Route = createFileRoute('/dashboard_/join')({
  ssr: false,
  validateSearch: (search: Record<string, unknown>): JoinSearch => {
    const out: JoinSearch = {};
    const ticket = text(search.__clerk_ticket);
    const status = text(search.__clerk_status);
    const team = text(search.team);
    if (ticket) out.__clerk_ticket = ticket;
    if (status) out.__clerk_status = status;
    if (team) out.team = team;
    return out;
  },
  component: JoinRoute,
});

function JoinRoute() {
  const search = Route.useSearch();
  return (
    <ClerkScope>
      <JoinTeamPage
        ticket={search.__clerk_ticket}
        status={search.__clerk_status}
        team={search.team}
        formAppearance={authFormAppearance}
      />
    </ClerkScope>
  );
}
